import React, { createContext, useContext, useState, ReactNode } from "react";

interface EvangelismAssistantContextType {
  messages: Array<{ id: string; sender: "user" | "ai"; text: string }>;
  addMessage: (sender: "user" | "ai", text: string) => void;
  resetChat: () => void;
}

const EvangelismAssistantContext = createContext<EvangelismAssistantContextType | undefined>(undefined);

export const useEvangelismAssistant = () => {
  const context = useContext(EvangelismAssistantContext);
  if (context === undefined) {
    throw new Error("useEvangelismAssistant must be used within an EvangelismAssistantProvider");
  }
  return context;
};

export const EvangelismAssistantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [messages, setMessages] = useState<Array<{ id: string; sender: "user" | "ai"; text: string }>>([]);

  let messageCounter = 0;
  
  const addMessage = (sender: "user" | "ai", text: string) => {
    const newMessage = {
      id: `${Date.now()}-${++messageCounter}`,
      sender,
      text
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const resetChat = () => {
    setMessages([]);
  };

  const value = {
    messages,
    addMessage,
    resetChat
  };

  return (
    <EvangelismAssistantContext.Provider value={value}>
      {children}
    </EvangelismAssistantContext.Provider>
  );
};